<!--
* 组件名 : 向下滚动提示
* 开发者 : LH
*
* 参数:
* 事件: null
*
-->

<template>
  <section class="scroll-next" :class="{ fixed, dark }">
    <div class="scroll-next-arrow">
      <svg width="50px" height="50px" viewBox="0 0 50 50">
        <circle cx="25" cy="25" r="24" ref="circle" :style="circleStyle" />
      </svg>
      <v-btn class="expand_more" @btnClick="on_next">
        <v-icon>expand_more</v-icon>
      </v-btn>
    </div>
  </section>
</template>

<script>
import { mapMutations } from "vuex";
import "./index.scss";
export default {
  name: "v-scroll-next",
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    this.timer = null;
    return {
      progress: 0,
      circleStyle: {
        "stroke-dasharray": 0,
        "stroke-dashoffset": 0,
      },
    };
  },
  mounted() {
    this.circleStyle["stroke-dashoffset"] = this.$refs.circle.getTotalLength();
    this.circleStyle["stroke-dasharray"] = this.$refs.circle.getTotalLength();
    $(window).on("mousewheel.scrollNext", this.scroll_next.bind(this));
  },
  beforeDestroy() {
    window.clearTimeout(this.timer);
    $(window).off("mousewheel.scrollNext");
  },
  methods: {
    ...mapMutations("global", ["updateScrollNextAnimate"]),
    on_next() {
      let customRoutes = this.$router.options.routes;
      let currentIndex = 0;
      customRoutes.map((item, i) => {
        if (item.name === this.$route.name) currentIndex = i;
      });

      this.updateScrollNextAnimate(true);
      this.$router.push({ path: customRoutes[currentIndex + 1].path });
    },
    progress_to(num) {
      let offset =
        this.circleStyle["stroke-dasharray"] -
        this.circleStyle["stroke-dasharray"] * num;

      $(this.$refs.circle)
        .velocity("stop")
        .velocity(
          {
            "stroke-dashoffset": offset,
          },
          {
            duration: 120,
            easing: "ease-out",
          }
        );
    },
    scroll_next(e) {
      let pageTop =
        $(".parallax-box").length > 0
          ? $(window).height() * 2
          : $(window).height();
      if (window.scrollY + pageTop < document.body.offsetHeight - 20) return;

      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.progress_to(0);
        this.progress = 0;
      }, 750);

      if (this.progress >= 1) {
        window.clearTimeout(this.timer);
        this.progress = 1;
        $(window).off("mousewheel.scrollNext");
        this.on_next();
      }

      this.progress += e.originalEvent.deltaY * 0.0006;
      this.progress = Math.max(
        0,
        Math.min(1, Math.ceil(this.progress * 1000) / 1000)
      );
      this.progress_to(this.progress);
    },
  },
};
</script>
